import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

import { Skeleton } from "antd";
import { useQuery } from "@apollo/client";

import Utils from "utils";
import { PROJECTS_QUERY } from "graphql/query/project";

const PublicRoute = () => {
  const user = useSelector((state) => state.user.user);
  const { token } = useSelector((state) => state.auth);
  const { data: projectsData, loading: projectsLoading } = useQuery(
    PROJECTS_QUERY,
    {
      variables: {
        ncpId: Utils.getCompanyId(),
        filter: JSON.stringify({ deleted: false }),
      },
      skip: !user || !token,
      fetchPolicy: "no-cache",
      onError: (error) => {},
    }
  );

  // Show loading skeleton if user is logged in and projects data is still loading
  if (token && (!user || projectsLoading)) {
    return <Skeleton active title={false} />;
  }

  // Navigate to the dashboard of the first project if user is logged in
  if (token && projectsData?.projects?.edges?.length > 0) {
    const firstProject = projectsData.projects.edges[0].node;
    const projectId = Utils.decodeId(firstProject.id);
    const companyId = firstProject.ncp_project_id;
    return <Navigate to={`/${companyId}/${projectId}/dashboard/home`} />;
  }

  // Render child components for public routes
  return <Outlet />;
};

export default PublicRoute;
